import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IResetUserMfaVerifiersParams {
  userIds: string[];
}

export class ResetUserMfaVerifiers extends Request<IResetUserMfaVerifiersParams, IResult> {
  constructor(userIds: string[]) {
    super('resetMFAVerifiers', { userIds: userIds });
  }
}
